export default
    {
        // url: this.$store.state.http.ceye.YYYY,
        listInstrumental: "/ceye/listInstrumental",
        guardaInstrumental: "/ceye/guardaInstrumental",
        guardaJuego: "/ceye/guardaJuego",
        listJuegos: "/ceye/listJuegos",
        guardaCarga: "/ceye/guardaCarga",
        listCarga: "/ceye/listCarga",
        getArchivo: "/ceye/getArchivo",
        guardaItamCarga:"/ceye/guardaItamCarga",
    }
